import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Handles the Emergent Google Auth return: exchanges #session_id server-side, then heads to the dashboard.
export default function AuthCallback() {
  const { loginWithData } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams((location.hash || "").replace(/^#/, ""));
    const sessionId = params.get("session_id");
    if (!sessionId) {
      window.history.replaceState(null, "", window.location.pathname);
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        loginWithData(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (err) {
        toast.error(apiError(err));
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/login", { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A]" data-testid="auth-callback">
      <div className="h-10 w-10 rounded-full border-2 border-blue-500 border-t-transparent animate-spin" />
    </div>
  );
}
